module.exports = __webpack_public_path__ + "img/icon-youtube.8e2f566f.svg";